import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { getPageSEO } from "../utils/seoData";
import JgShell, { AR_JAMIL } from "../@components/jg/JgShell";

const NotFound = () => {
  const seoData = getPageSEO("home");

  return (
    <JgShell>
      <SEO
        title={`Page Not Found | ${seoData?.title || "Jamil Global"}`}
        description="The page you are looking for does not exist. Please check the URL or browse our services, case studies, and blog."
        url="/404"
        noindex={true}
        nofollow={true}
      />

      <section
        aria-label="Page not found"
        style={{
          position: "relative",
          overflow: "hidden",
          isolation: "isolate",
          minHeight: "calc(100svh - 64px)",
          display: "flex",
          alignItems: "center",
          paddingTop: "64px",
        }}
      >
        <span
          aria-hidden="true"
          style={{
            position: "absolute",
            top: "50%",
            right: "-0.05em",
            transform: "translateY(-50%)",
            fontFamily: "var(--jg-font-arabic)",
            fontSize: "clamp(11rem, 30vw, 28rem)",
            lineHeight: 1,
            color: "transparent",
            WebkitTextStroke: "1px rgba(193, 71, 31, 0.25)",
            pointerEvents: "none",
            userSelect: "none",
            whiteSpace: "nowrap",
            zIndex: -1,
          }}
        >
          {AR_JAMIL}
        </span>

        <div className="jg-wrap" style={{ width: "100%" }}>
          <p className="jg-label" style={{ marginBottom: "1.5rem" }}>
            Error 404 — Page not found
          </p>
          <h1
            style={{
              fontFamily: "var(--jg-font-display)",
              fontSize: "clamp(6rem, 20vw, 16rem)",
              lineHeight: 0.9,
              letterSpacing: "-0.03em",
              fontWeight: 430,
            }}
          >
            404
          </h1>
          <p
            style={{
              marginTop: "2rem",
              maxWidth: "44ch",
              fontSize: "1rem",
              lineHeight: 1.6,
              color: "var(--jg-ink-soft)",
            }}
          >
            This URL is not indexed as a valid page. You can return to our
            homepage or explore key sections.
          </p>
          <div
            style={{
              marginTop: "2.5rem",
              display: "flex",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <Link to="/" className="jg-btn jg-btn--solid">
              Back to home <span aria-hidden="true">→</span>
            </Link>
            <Link to="/services/ai-integration" className="jg-btn jg-btn--ghost">
              Explore services
            </Link>
            <Link to="/case-studies" className="jg-btn jg-btn--ghost">
              View case studies
            </Link>
            <Link to="/blog" className="jg-btn jg-btn--ghost">
              Read the blog
            </Link>
          </div>
        </div>
      </section>
    </JgShell>
  );
};

export default NotFound;
